import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Overview from "@/pages/home/components/Overview";
import LiveZones from "@/pages/home/components/LiveZones";
import StreamerStyles from "@/pages/home/components/StreamerStyles";
import ShortVideo from "@/pages/home/components/ShortVideo";
import WelfareAccess from "@/pages/home/components/WelfareAccess";
import VipCompare from "@/pages/home/components/VipCompare";
import NightSlot from "@/pages/home/components/NightSlot";
import EfficiencyTips from "@/pages/home/components/EfficiencyTips";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="w-full bg-background-50 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <LiveZones />
        <StreamerStyles />
        <ShortVideo />
        <WelfareAccess />
        <VipCompare />
        <NightSlot />
        <EfficiencyTips />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}